<template>
<v-card
    
>
<v-card-text
    v-if="value == null"
>
    Null Layer: {{layer}}
</v-card-text>
<v-card-text
    v-if="value != null"
>


    <LineChart 
        :chart-data="value.chart_data" 
        :chart-options="getChartOptions(value.layer)" 
        style="height: 350px"
    />

    <div
        style="margin-bottom: 25px"
    >

        <v-text-field
            :label="getLayerProps(value.layer).title"
            :value="value.x ?? 'Layer not in use'"
            readonly
            disabled
        />

        <b>Frequently Asked Questions (FAQ): {{getLayerProps(value.layer).title}}</b>
        <m-model-r1-faq
            :layer="value.layer"
        />
    </div> 

</v-card-text>
</v-card>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

export default {
    components: {
        LineChart
    },

    props: {
        layer: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            value: null,
            x: null,
        }
    },

    mounted () {
        this.doUpdate();
    },


    methods: {
        doUpdate()
        {
            if ( this.layer == null )
            {
                this.value = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/model/r1/inference-details/:organization_id/:bulk_message_id/:bulk_message_recipient_id/:layer',

                params: {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                    'bulk_message_recipient_id': this.$route.params.bulk_message_recipient_id,
                    'layer': this.layer,
                },
            
                'on_success': (data) => {
                        this.value = data;
                        
                        if ( this.value.chart_data.datasets.length >= 2 )
                        {
                            this.value.chart_data.datasets[0].borderColor = 'rgba(255,100,100,1.0)';
                            this.value.chart_data.datasets[1].backgroundColor = 'rgba(0,0,0,0.1)';
                        }
                    },
            
                'on_error': 'Unable to load layer '+this.layer,
            });
        },

        onClickRestoreDefaults()
        {
            this.$rc.confirm({
                'title': 'Reset Defaults',
                'body': 'Reset layer to default settings?',
                'btn_text_ok': 'Reset',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.value.params = this.value.params_default;
                    this.doUpdate();
                },
            });
        },

        getLayerProps(layer)
        {
            if ( layer == 'background' )
            {
                return {
                    'title': 'Uncertainty Background',
                    'x_axis_title': 'Customer Hash (modulo 100)',
                };
            } 

            if ( layer == 'days-since-last-promotional-message' )
            {
                return {
                    'title': 'Time Since Last Promotional Message',
                    'x_axis_title': 'Days since last promotional message'
                };
            }

            if ( layer == 'days-since-last-non-club-purchase' )
            {
                return {
                    'title': 'Time Since Last Non Club Order Placed',
                    'x_axis_title': 'Days since last (non-club) order placed',
                };
            }

            if ( layer == 'bulk-message-order-attribution-percentile' )
            {
                return {
                    'title': 'Bulk Message Order Attribution Percentile',
                    'x_axis_title': 'Bulk message order attribution (percentile)',
                };
            }

            if ( layer == 'is-active-club-member' )
            {
                return {
                    'title': 'Is Active Club Member?',
                    'x_axis_title': 'Less than 50, not a club member, greater than 50, club member',
                };
            }

            return {
                'title': 'Unknown',
                'x_axis_title': 'Unknown',
            };
        },

        getChartOptions(layer)
        {
            let props = this.getLayerProps(layer);

            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        type: 'linear',
                        title: {
                            display: true,
                            text: props.x_axis_title,
                        },
                        ticks: {
                            stepSize: 1
                        },
                    },
                    y: {
                        type: 'linear',
                        title: {
                            display: true,
                            text: 'Sentiment Score (Percentile)'
                        },
                            ticks: {
                            stepSize: 1
                        }
                    },
                },
                plugins: {
                    tooltip: {
                        enabled: false
                    },
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true, 
                        text: props.title,
                    }
                },
                animation: {
                    duration: 0
                }
            };
        }
    },

    watch: {
        layer(newValue, oldValue) {
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>
.edit-container
{
    display: flex;
    gap: 15px;
}
.edit-ctrl-container
{
    flex-grow: 1;
}
.edit-btn-container
{
    flex-grow: 0;
    margin-top: 15px;
}
</style>